import {
    // eslint-disable-next-line no-restricted-imports
    FocusPage,
    StripeActionButton,
    StripeHeader,
    StripeTitle,
} from '@george-labs.com/design-system';
import type { FC } from 'react';

import { t } from '@luna/i18n';
import type { BankMessage } from '@shared/bank-messages-utils';
import { getFeatureConfig } from '@luna/feature-config';

import { MustReadMessage } from './MustReadMessage';

interface Props {
    message: BankMessage;
    onRefetch(): void;
    onLogout(messageId: string): void;
    onMessageAcknowledge(messageId: string): void;
}

export const MustReadMessageFocusPage: FC<Props> = ({
    message,
    onLogout,
    onMessageAcknowledge,
}) => {
    const stripeColor = getFeatureConfig((config) => config.base.defaultStripeColor);

    return (
        <FocusPage
            stripeHeader={
                <StripeHeader
                    color={stripeColor}
                    center={<StripeTitle>{t('mustReadMessages.title')}</StripeTitle>}
                    right={
                        <StripeActionButton
                            data-cy="logout-option"
                            icon={StripeActionButton.ICON.LOGOUT}
                            onClick={() => onLogout(message.id)}
                        >
                            {t('main.menu.logout')}
                        </StripeActionButton>
                    }
                    sticky
                    fullWidth
                />
            }
        >
            <MustReadMessage
                color={stripeColor}
                message={message}
                onMessageAcknowledge={onMessageAcknowledge}
            />
        </FocusPage>
    );
};
